{
    "page": 1,
    "size": 10,
    "total": 1,
    "total_pages": 1,
    "data": [
        {
            "loan_application_id": "3912e960-7795-434f-bc47-d277ff43937e",
            "loan_amount": 2000000,
            "approved_term": 0,
            "requested_amount": 2000000,
            "approved_amount": 2000000,
            "selected_amount": 2000000,
            "requested_term": 36,
            "approved_max_term": 36,
            "approved_min_term": 18,
            "selected_term": 36,
            "interest_rate": 29,
            "residual_value": 0,
            "monthly_payment": 0,
            "score": 0,
            "score_code": "-",
            "result": null,
            "active": true,
            "id_model": "8ed8b831-95e3-45e5-b5bc-9ba059184888",
            "date_model": "2025-12-18T20:02:20.904202",
            "minimum_percentage_dispersion": null,
            "maximum_percentage_dispersion": null,
            "external_rating_id": null,
            "requested_advance_value": null,
            "approved_max_advance_value": null,
            "approved_min_advance_value": null,
            "selected_advance_value": null,
            "requested_residual_value": null,
            "approved_max_residual_value": null,
            "approved_min_residual_value": null,
            "selected_residual_value": null,
            "requested_advance_percentage": null,
            "approved_max_advance_percentage": null,
            "approved_min_advance_percentage": null,
            "selected_advance_percentage": null,
            "requested_residual_percentage": null,
            "approved_max_residual_percentage": null,
            "approved_min_residual_percentage": null,
            "selected_residual_percentage": null,
            "created_at": "2026-02-23T23:56:14.039713",
            "updated_at": "2026-02-23T23:56:14.039740",
            "id": "2584ff13-2ac9-4b92-b217-99daf3f90c0c"
        }
    ]
}
